import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import TotpChallenge from "@/pages/TotpChallenge";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser, refresh } = useAuth();
  const hasProcessed = useRef(false);
  const [totp, setTotp] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const session_id = match[1];
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id });
        if (data.requires_totp) {
          // Superadmin — stay on the callback screen with the TOTP UI
          setTotp({ email: data.email, hasTotp: !!data.has_totp });
          return;
        }
        setUser(data.user);
        navigate("/dashboard", { replace: true, state: { user: data.user } });
      } catch (e) {
        navigate("/login?error=oauth_failed", { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  if (totp) {
    return (
      <TotpChallenge
        email={totp.email}
        hasTotp={totp.hasTotp}
        onSuccess={async (user) => {
          setUser(user);
          await refresh();
          navigate(user?.is_superadmin ? "/superadmin" : "/dashboard", { replace: true });
        }}
        onCancel={() => navigate("/login", { replace: true })}
      />
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F4F7FB]">
      <div className="text-center">
        <div className="flex gap-2 justify-center mb-4">
          <span className="dot w-2 h-2 rounded-full bg-[#3A8FA5]" style={{ animationDelay: "0s" }}></span>
          <span className="dot w-2 h-2 rounded-full bg-[#3A8FA5]" style={{ animationDelay: "0.2s" }}></span>
          <span className="dot w-2 h-2 rounded-full bg-[#3A8FA5]" style={{ animationDelay: "0.4s" }}></span>
        </div>
        <p className="text-sm text-[#5F758F]">Authentification en cours…</p>
      </div>
    </div>
  );
}
